import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

import Axios from "@/lib/axios-instance";

type Permission = {
    module_id: string;
    user_id: string;
    can_get_list: boolean;
    can_get_one: boolean;
    can_create: boolean;
    can_update: boolean;
    can_delete: boolean;
};

type APIPayload = {
    data: Permission[];
};

type ResponseType = {
    data: any;
    meta: any;
};

export const updatePermission = async (payload: APIPayload) => {
    try {
        const response = await Axios.post(`/user-permissions/bulk-create-or-update`, payload.data);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useUpdatePermission = () => {
    return useMutation<ResponseType, Error, APIPayload>({
        mutationFn: (payload: APIPayload) => updatePermission(payload),
        onSuccess: (data) => {
            toast.success("Updated Permission Successfully");
            console.log(data);
        },
        onError: (error) => {
            toast.error("Update Permission Failed", { description: error.message });
        },
    });
};
